<template>
  <!-- INICIO ITEM COLLAPSE -->
  <div class="item">
    <a
      :id="`collapseLink${index}`"
      class="collapseLink item--head row align-items-center no-gutters"
      @click="AbrirCollapse(index)"
    >
      <div class="col-12 col-md-8">
        <div class="date">
          <span>{{ dataDia }}</span>
          <small>{{ formatadoMesEAno }}</small>
        </div>

        <div class="action">
          <div v-if="registroCancelado">
            <strike>
              <template v-if="tipo == 'PAGAMENTO'">
              <span>{{ nomeEmpresa }} - </span>
              <span>{{ tipo }}</span>
              <small>{{ descricao }}</small>
              </template>
              <template v-else-if="tipo == 'EXTORNO'">
              <span> ESTORNO </span>
              <small> Estorno de valor do investimento </small>
              </template>
              <template v-else-if="tipo == 'INVESTIMENTO' && descricao == 'Investimento realizado'">
              <span> RESERVA DE INVESTIMENTO </span>
              <small> {{ descricao }} </small>
              </template>
              <template v-else>
              <span>{{ tipo }}</span>
              <small>{{ descricao }}</small>
              </template>  
            </strike>
          </div>
          <div v-else>
            <template v-if="tipo == 'PAGAMENTO'">
            <span>{{ nomeEmpresa }} - </span>
            <span>{{ tipo }}</span>
            <small>{{ descricao }}</small>
            </template>
            <template v-else-if="tipo == 'EXTORNO'">
            <span> ESTORNO </span>
            <small> Estorno de valor do investimento </small>
            </template>
            <template v-else-if="tipo == 'INVESTIMENTO' && descricao == 'Investimento realizado'">
            <span> RESERVA DE INVESTIMENTO </span>
            <small> {{ descricao }} </small>
            </template>
            <template v-else>
            <span>{{ tipo }}</span>
            <small>{{ descricao }}</small>
            </template> 
          </div>
        </div>
      </div>

      <div v-if="registroCancelado" class="col-12 col-md-4 text-left text-md-right">
        <strike><span class="valor" :class="classeItem">R$ {{ formatadoValor }}</span></strike>
      </div>
      <div v-else class="col-12 col-md-4 text-left text-md-right">
        <span class="valor" :class="classeItem">R$ {{ formatadoValor }}</span>
      </div>
    </a>

    <!-- INICIO DETALHES DA OPERACAO -->
    <div :id="`collapse${index}`" class="collapse item--info">
      <WalletDetalhe :operacao="item" />
    </div>
    <!-- TERMINO DETALHES A OPERACAO -->

    <!--<div :id="`collapse${index}`" class="collapse item--info">

            <div class="row">
                <div class="col-12 col-md-7 sep">
                    <div>
                        <p>
                            <strong>Informações</strong><br>
                            {{ item.Detalhes.Descricao }}
                        </p>
                    </div>
                    <table>
                        <thead>
                            <th colspan="2" > {{ detalheTitulo }} </th>
                        </thead>

                        LOANSPAYMENT
                        <tbody>

                            <tr v-if="item.Detalhes.ValorBruto">
                                <td> Valor Bruto </td>
                                <td class="text-right"> {{ item.Detalhes.ValorBruto }} </td>

                            </tr>

                            <tr v-if="item.Detalhes.Ipmt">

                                <td> Ipmt </td>
                                <td class="text-right"> {{ item.Detalhes.Ipmt }} </td>
                            </tr>

                            <tr v-if="item.Detalhes.Valor" >

                                <td> Valor </td>
                                <td class="text-right"> {{ item.Detalhes.Valor }} </td>
                            </tr>

                        </tbody>
                     ########################



                        <div class="btns">
                            <router-link  :to="`/investimentos/carteira-investimento/comprovante/${item.id}?type=CREDITO`" class="btn btn-link"><img src="/static/assets/images/ico-printer-2.svg" alt="Icone impressora"> Imprimir detalhes</router-link>
                        </div>

                         <div class="btns">
                            <router-link
                                :to="`/investimentos/carteira-investimento/comprovante/5d9f48a1413a6183b02c3d0d?type=CREDITO`"
                                class="btn btn-link">

                                    <img src="/static/assets/images/ico-printer-2.svg" alt="Icone impressora">
                                    Imprimir detalhes

                            </router-link>
                        </div>






                    </table>

                </div>
            </div>
    </div>-->
  </div>
  <!-- FINAL ITEM COLLAPSE -->
</template>

<script>
import WalletService from "../../services/api/wallet";
import WalletDetalhe from "../../components/Wallet/WalletDetalhes";
    import ApiClient from '../../utils/api-client'

export default {
  components: {
    WalletDetalhe
  },

  data() {
    return {
      operacaoDetalhes: {}
    };
  },

  props: {
    item: { type: Object },
    index: { type: Number }
  },

  computed: {
    dataDia() {
      return this.pegarDataDia(this.item.Data);
    },
    formatadoMesEAno() {
      return this.pegarDataFormatada(this.item.Data);
    },
    formatadoValor() {
      return this.formatarDinheiro(this.item.Valor);
    },
    tipo() {
      return this.item.Tipo;
    },
    descricao() {
      return this.item.Descricao;
    },
    classeItem() {
      return this.pegarClasseItem(this.item.Valor);
    },
    nomeEmpresa() {
        const { NomeEmpresa } = this.item.Detalhes.Pagamento
        return NomeEmpresa
    },
    registroCancelado() {
      return this.item.Cancelado;
    }
  },


  methods: {

    async AbrirCollapse(id) {
      let detalhesOperacao;

      $(".collapse").collapse("hide");
      $(".active").removeClass("active");
      $(`#collapse${id}`).collapse("toggle");

      console.log(!$(`#collapseLink${id}`).hasClass("active"));

      if(!$(`#collapseLink${id}`).hasClass("active")) {

          $(`#collapseLink${id}`).addClass("active");

      }
    },

    activeCollapse(id) {
      let el = document.getElementById(id);

      let classAct = el.classList.contains("active");

      if (classAct) el.classList.remove("active");
      else el.classList.add("active");
      
    },

    pegarClasseItem(valor) {
      if (valor > 0) return "text-success";
      else return "text-danger";
    },

    pegarDataDia(data) {
      data = new Date(data);

      data = data.toLocaleString("pt-BR", { timeZone: "UTC" }).split(" ")[0];

      data = data.split("/");

      return data[0];
    },

    pegarDataFormatada(data) {
      data = new Date(data);

      const mes = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
      ];

      data = data.toLocaleString("pt-BR", { timeZone: "UTC" }).split(" ")[0];

      data = data.split("/");

      return `${mes[data[1] - 1]} - ${data[2].substring(2)}`;
    },
    formatarDinheiro(value) {
      if (value != null) {
        if (typeof value == "string") value = parseFloat(value);

        let options = {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        };

        return value.toLocaleString("pt-BR", options);
      }

      return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.date {
  text-transform: uppercase;
  width: 4em !important;
}

.registro-cancelado {
   text-decoration: line-through;
}
</style>


// WEBPACK FOOTER //
// src/components/Wallet/WalletExtratoListaItem.vue